module.exports = __webpack_public_path__ + "img/about-results.668bf9ca.png";